import React from 'react';
import Reflux from 'reflux';
import classNames from 'classnames';
import TimeUtil from 'time';
import { Map, OrderedMap } from 'immutable';
import {
  ColorRGBs,
  EditableCellTypes,
} from 'flux/stores/cuesheet/CuesheetConstants';
import RTEReadOnly from 'shared/components/rte/rteReadOnly';
import { DisplayTypes } from 'shared/constants/FlowConstants';
import { PrintableTypes } from 'shared/constants/Printable';
import HighlightMixin from 'main/components/show/cuesheet/highlightCellMixin.js';
import CellHelper from 'main/components/show/cuesheet/cellHelper';
import { getPlainTextFromRawRTEState } from '@shoflo-rundown/draft-js-utils';
import qs from 'query-string';
import TimeDisplayTypes from 'shared/constants/TimeDisplayTypes';
import GuestCuesheetStore from 'flux/stores/cuesheet.guest/GuestCuesheetStore';

export default React.createClass({
  displayName: 'GuestCuesheetRow',

  mixins: [HighlightMixin, Reflux.connect(GuestCuesheetStore, 'cuesheet')],

  propTypes: {
    row: React.PropTypes.object,
    event: React.PropTypes.object,
    show: React.PropTypes.object,
    gridType: React.PropTypes.string,
    userId: React.PropTypes.object,
    columns: React.PropTypes.object,
    tags: React.PropTypes.object,
  },

  render() {
    const { item } = this.props;

    return item.get('titleView') ? this._getTitleRow() : this._getRow();
  },

  /**
   * Retrieve a title row.
   */
  _getTitleRow() {
    const { item, titleRowsEnabled } = this.props;

    if (!this._isTypeShow() && !titleRowsEnabled) return null;

    return (
      <tr
        ref={`row-${item.get('_id')}`}
        style={this._getRowStyles()}
        className={this._getRowClasses()}
      >
        {this._getTitleRowCells()}
      </tr>
    );
  },

  /**
   * Retrieve a standard row
   */
  _getRow() {
    const { item } = this.props;
    return (
      <tr
        ref={`row-${item.get('_id')}`}
        style={this._getRowStyles()}
        className={this._getRowClasses()}
      >
        {this._getRowCells()}
      </tr>
    );
  },

  _getRowStyles() {
    const { item } = this.props;
    const style = this.getGlobalHighlightStyle(item);

    return style;
  },

  _getRowClasses(custom) {
    const { item, gridType } = this.props;

    const rowClasses = [];

    if (!gridType || gridType === DisplayTypes.show) {
      const titleClass = item.get('titleView')
        ? 'printable-cuesheet-title-view'
        : null;
      rowClasses.push(titleClass);
    } else {
      const gridTitleClass = item.get('titleView')
        ? 'printable-cuesheet-title-view printable-cuesheet-grid-title-view '
        : null;
      rowClasses.push(gridTitleClass);
    }

    return classNames(rowClasses, custom);
  },

  /**
   * Get cells for title row
   */
  _getTitleRowCells() {
    const { item, gridType, columns } = this.props;

    /**
     * If show then return normal row cells.
     */
    if (!gridType || gridType === DisplayTypes.show) {
      return this._getRowCells();
    }

    //Flag to determine for title row has been added to the first
    //column in the title row.
    let titleAdded = false;

    // return columns.map((column, id) => {
    return columns.map(() => {
      const titleFormatStyle = CellHelper.getFormatStyles(
        item.get('titleFormat'),
      );

      let cellNode = <span />;

      //No need to render if there is no state...
      if (
        item.get('rteTitleState') &&
        getPlainTextFromRawRTEState(item.get('rteTitleState').toJS())
      ) {
        cellNode = (
          <RTEReadOnly
            rteState={item.get('rteTitleState')}
            customColors={ColorRGBs}
          />
        );
      } else {
        cellNode = <span>Title Row</span>;
      }

      const cellClasses = classNames('cs-cell', 'printable-cuesheet-item');

      if (!titleAdded) {
        titleAdded = true;
        return (
          <td
            style={titleFormatStyle}
            colSpan={columns.size}
            className={cellClasses}
          >
            {cellNode}
          </td>
        );
      }
    });
  },

  /**
   * Get cells for table row
   */
  _getRowCells() {
    const { cuesheet } = this.state;

    const guestColumns = cuesheet.get('guestColumns');

    const { item } = this.props;

    const cells = this._getUtilityCells().concat(item.get('cells'));

    return guestColumns
      .map((column, id) => {
        if (!cells.get(id)) return <td />;

        /**
         * Fix the width of columns. This makes all columns accross the page tables
         * to have consistent column sizes.
         */
        const styles = Object.assign(
          {},
          CellHelper.getFormatStyles(cells.getIn([id, 'format'])),
          cells.getIn([id, 'styles']),
        );

        const cellClasses = classNames('cs-cell', cells.getIn([id, 'classes']));

        /**
         * If label cell.
         */
        if (id === 'labels')
          return this._getLabelsCell(
            id,
            cells.getIn([id, 'labels']),
            cellClasses,
          );

        /**
         * If time cell. Add startTime and presetTime to the same table data cell
         */
        if (id === EditableCellTypes.ItemStartTime)
          return this._getStartTimeCell(id, styles, cellClasses);

        /**
         * If time cell. Add startTime and presetTime to the same table data cell
         */
        if (id === EditableCellTypes.ItemPresetDuration)
          return this._getPresetCell(id, styles, cellClasses);

        /**
         * If duration, check for format
         */
        if (id === EditableCellTypes.ItemDuration)
          return this._getDurationCell(id, styles, cellClasses);

        if (cells.getIn([id, 'rteState'])) {
          const rteState = cells.getIn([id, 'rteState']);
          return (
            <td style={styles} className={cellClasses}>
              <RTEReadOnly rteState={rteState} customColors={ColorRGBs} />
            </td>
          );
        }

        return (
          <td style={styles} className={cellClasses}>
            {cells.getIn([id, 'text'])}
          </td>
        );
      })
      .toArray();
  },

  /**
   * Get Utility Cells (item, number, etc.);
   */
  _getUtilityCells() {
    const { item, show } = this.props;

    /**
     * Grid Cells:
     *
     * When number, duration, or time are hidden then those columns will be
     * removed from the column list in the PrintableCuesheetStore.
     * Notes will always be removed for grids in the store. Once the
     * columns are removed from the column list the cells will never be used.
     *
     * To view the logic that determines what cells are rendered look in the
     * store at the column logic.
     */

    let utilityCells = OrderedMap({
      [`${EditableCellTypes.ItemNumber}`]: Map({
        text: item.get('numberAdjusted'),
        classes: 'printable-cuesheet-number',
      }),
      labels: Map({
        labels: item.get('labels'),
        classes: 'printable-cuesheet-labels',
      }),
      [`${EditableCellTypes.ItemStartTime}`]: Map({
        classes: 'printable-cuesheet-start-time',
      }),
      [`${EditableCellTypes.ItemPresetDuration}`]: Map({
        classes: 'printable-cuesheet-preset-time',
      }),
      [`${EditableCellTypes.ItemDuration}`]: Map({
        classes: 'printable-cuesheet-duration-time',
      }),
      [`${EditableCellTypes.ItemTitle}`]: Map({
        rteState: item.get('rteTitleState'),
        classes: 'printable-cuesheet-item',
        styles: CellHelper.getFormatStyles(item.get('titleFormat')),
      }),
      [`${EditableCellTypes.ItemDescription}`]: Map({
        rteState: item.get('rteDescriptionState'),
        classes: 'printable-cuesheet-description',
        styles: CellHelper.getFormatStyles(item.get('descriptionFormat')),
      }),
    });

    if (!show.get('displayStartTime')) {
      utilityCells = utilityCells.delete(EditableCellTypes.ItemStartTime);
    }

    if (!show.get('displayPresetDuration')) {
      utilityCells = utilityCells.delete(EditableCellTypes.ItemPresetDuration);
    }

    if (!show.get('displayDuration')) {
      utilityCells = utilityCells.delete(EditableCellTypes.ItemDuration);
    }

    if (!show.get('displayItemDescriptions')) {
      utilityCells = utilityCells.delete(EditableCellTypes.ItemDescription);
    }

    return utilityCells;
  },

  _getDurationCell(id, styles, classes) {
    const { show, item, printableType } = this.props;

    let displayDuration = show.get('displayDuration');
    const durationDisplayType = show.get('durationDisplayType');
    const displayDurationPerRow = item.get('displayDurationClock');
    const durationValue = item.get('durationInSeconds');

    if (printableType === PrintableTypes.custom) {
      const { columnOrder } = qs.parse(window.location.search, {
        arrayFormat: 'index',
      });
      displayDuration =
        columnOrder.indexOf(EditableCellTypes.ItemDuration) !== -1
          ? true
          : false;
    }

    let durationText = TimeUtil.getShorthandDuration(durationValue);

    if (durationDisplayType === TimeDisplayTypes.sixDigitTime) {
      durationText = TimeUtil.getFormattedDuration(durationValue);
    }
    if (durationDisplayType === TimeDisplayTypes.clockTime) {
      durationText = TimeUtil.getShorthandFormattedPresetDuration(
        durationValue,
      );
    }

    /**
     * Start Times
     */
    let durationNode = null;

    if (displayDuration && displayDurationPerRow) {
      durationNode = <p>{durationText}</p>;
    }

    return (
      <td style={styles} className={classes}>
        {durationNode}
      </td>
    );
  },

  _getLabelsCell(id, labels, classes) {
    const { item, tags } = this.props;

    if (!tags) return <td />;

    const rowTagNodes = [];

    item.get('labels').forEach((labelId) => {
      const label = tags.get(labelId);
      // const labelColor = label.get('text') === 'Unassigned' ? '#434343' : getTextColorForHex(label.get('color'));

      rowTagNodes.push(
        <div
          key={label.get('_id')}
          className="cs-label-cell-content"
          style={{
            background: label.get('color'),
            color: label,
          }}
        >
          <div className="cs-label-inner">{label.get('text')}</div>
        </div>,
      );
    });

    return <td className={classes}>{rowTagNodes}</td>;
  },

  _getStartTimeCell(id, styles, classes) {
    const { show, item, event, printableType } = this.props;

    let displayStartTime = show.get('displayStartTime');

    const displayStartTimePerRow = item.get('displayStartTimeClock');

    /**
     * If presetTime or start time are hidden via a query from a custom
     * printable export then don't display them.
     */
    if (printableType === PrintableTypes.custom) {
      const { columnOrder } = qs.parse(window.location.search, {
        arrayFormat: 'index',
      });
      displayStartTime =
        columnOrder.indexOf(EditableCellTypes.ItemStartTime) !== -1
          ? true
          : false;
    }

    /**
     * Start Times
     */
    let startTimeNode = null;

    if (displayStartTime && displayStartTimePerRow) {
      startTimeNode = (
        <p>
          {TimeUtil.getShorthandTimeUTC(
            item.get('startOnAdjusted'),
            event.get('twentyFourHourClock'),
          )}
        </p>
      );
    }

    return (
      <td style={styles} className={classes}>
        {startTimeNode}
      </td>
    );
  },

  _getPresetCell(id, styles, classes) {
    const { show, item, printableType } = this.props;

    let displayPresetDuration = show.get('displayPresetDuration');
    const presetDurationDisplayType = show.get('presetDurationDisplayType');

    const displayPresetClockPerRow = item.get('displayPresetClock');

    /**
     * If presetTime or start time are hidden via a query from a custom
     * printable export then don't display them.
     */
    if (printableType === PrintableTypes.custom) {
      const { columnOrder } = qs.parse(window.location.search, {
        arrayFormat: 'index',
      });
      displayPresetDuration =
        columnOrder.indexOf(EditableCellTypes.ItemPresetDuration) !== -1
          ? true
          : false;
    }

    /**
     * Preset Times
     */
    let presetTimeNode = null;

    if (displayPresetDuration && displayPresetClockPerRow) {
      const presetValue = item.get('presetDurationInSecondsAdjusted');

      let presetDuration = TimeUtil.getShorthandFormattedPresetDuration(
        presetValue,
      );

      if (presetDurationDisplayType === TimeDisplayTypes.sixDigitTime) {
        presetDuration = TimeUtil.getFormattedDuration(presetValue);
      }
      if (presetDurationDisplayType === TimeDisplayTypes.presetTime) {
        presetDuration = TimeUtil.getFormattedPresetDuration(presetValue);
      }

      const presetClasses = classNames('cs-cell cs-preset-time-cell', {
        'cs-preset-time-cell-over': presetValue < 0,
      });

      presetTimeNode = (
        <p className={classNames(presetClasses)}>{presetDuration}</p>
      );
    }

    return (
      <td style={styles} className={classes}>
        {presetTimeNode}
      </td>
    );
  },

  _isTypeShow() {
    const displayType = this.props.show.get('displayType');
    return !displayType || displayType === DisplayTypes.show;
  },
});
